module.exports = __webpack_public_path__ + "img/IMG_20200714_001241.dc154062.jpg";